import { Routes } from '@angular/router';
import { PublicLayoutComponent } from './core/layouts/public-layout/public-layout/public-layout.component';
import { AdminPanelLayoutComponent } from './core/layouts/admin-panel-layout/admin-panel/admin-panel.component';
import { LanguageResolverService } from './shared/services/common/language-resolver.service';
import { PATIENT_PORTAL_PREFIX } from './shared/constants/system-constants.model';

export const routes: Routes = [

  // Patient Panel routes goes here
  {
    path: PATIENT_PORTAL_PREFIX,
    component: AdminPanelLayoutComponent,
    loadChildren: () => import('./shared/constants/patient-routes').then(t => t.PATIENT_ROUTES),
    resolve: {
      language: LanguageResolverService
    }
  },
  //public routes goes here 
  {
    path: '',
    component: PublicLayoutComponent,
    loadChildren: () => import('./shared/constants/public-routes').then(t => t.PUBLIC_ROUTES),
    resolve: {
      language: LanguageResolverService
    }
  },
  // Admin Panel routes goes here
  {
    path: '',
    component: AdminPanelLayoutComponent,
    loadChildren: () => import('./shared/constants/admin-routes').then(t => t.ADMIN_ROUTES),
    resolve: {
      language: LanguageResolverService
    }
  },
];